var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPracticeRoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31,13 A14,14 0,1 0,31,41 A14,14 0,1 0,31,13",
    fill: "#7C1CFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31,17 A10,10 0,1 0,31,37 A10,10 0,1 0,31,17",
    fill: "#0D0D12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31,20 A7,7 0,1 0,31,34 A7,7 0,1 0,31,20",
    fill: "#FFFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3,22 L33.3,31.7 L30.7,31.7 L30.7,28.1 L26.9,28.1 L26.9,25.7 L30.7,25.7 L30.7,22 Z",
    fill: "#2A0D4D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5,35 L21.8,23.2 L24.1,26.1 L7.3,37.9 Z",
    fill: "#FFD000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7,22.2 L25.1,25.4 L27,23.7 L22.7,20.5 Z",
    fill: "#F7F3FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18,15 L22,19 L20,20.8 L16,16.8 Z",
    fill: "#00D4FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11,19 L17,21 L16.2,23.4 L10.2,21.4 Z",
    fill: "#00D4FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20,10 L22.7,16 L20.4,17 L17.7,11 Z",
    fill: "#00D4FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPracticeRoom);
export default __webpack_public_path__ + "static/media/practice-room.0ecdaf0bc7b816f6d9fe03f5879e3696.svg";
export { ForwardRef as ReactComponent };